import { render } from "./AddTagsModal.vue?vue&type=template&id=fe5b6432&scoped=true&ts=true"
import script from "./AddTagsModal.vue?vue&type=script&lang=ts"
export * from "./AddTagsModal.vue?vue&type=script&lang=ts"

import "./AddTagsModal.vue?vue&type=style&index=0&id=fe5b6432&scoped=true&lang=scss"

import exportComponent from "/home/ubuntu/buildAgent/work/a701a23a46ecd31f/bookit-pms/Solution/ClientApp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe5b6432"]])

export default __exports__